module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 4-e18d4869affa3429bd5bba2f0dff8048.jpg";